<template>
	<section ref="chats" class="Chats">
		<Entry
			v-for="(c, id) in filteredChats"
			:key="`chat_${c.id}_${id}`"
			:data="c"
			:showtime="showtime(c)"
			:delay="getDelay(c)"
			@reply="onReplyMessage"
			:typing="getTyping(c, id)"
			:current="isCurrent(c, id, filteredChats)"
			@updated="scroll"
		/>
	</section>
</template>

<script>
	import Entry from './Entry';
	import { mapState } from 'vuex';
	import { getChat, sendChat } from '../services/chat';
	import { fullDecode, sleep } from '../libs/utils';
	import whevent from 'whevent';
	import { logX } from '../common/libs/utils';

	let lastShowTime = null;
	let delay = 0;

	export default {
		components: {
			Entry
		},
		data() {
			return {
				delay: 0
			};
		},
		methods: {
			async onReplyMessage({ data, text, type, source, offline }) {
				logX('REPLY', 'blue', { data, text, type, source });
				let follow = true, from = 'user', hidden = false;
				if (type === 'calendar') {
					// sendChat({ data, text, type: 'text', from: 'user', follow: false, hidden: true });
					follow = false;
					from = 'bot';
					// text = '日時を選択して下さい。';
				} else if (['radio', 'checkbox'].includes(type)) {
					// sendChat({ data, text, type: 'text', from: 'user', follow: false, hidden: true });
					follow = false;
					from = 'bot';
					// text = '選択肢を選択して下さい。';
				} else if (['payment'].includes(type)) {
					// sendChat({ data, text, type: 'text', from: 'user', follow: false, hidden: true });
					follow = false;
					from = 'bot';
					offline = true;
					// text = '選択肢を選択して下さい。';
				} else if (type === 'url') {
					const uri = fullDecode(data.uri);
					if(data.uri_via == 'direct') {
						window.location.href = uri;
					} else {
						window.open(uri);
					}
					return;
				} else if(type === 'upload') {
					hidden = true;
				}
				sendChat({ data, text, type, from, follow, source, offline, hidden });
			},
			showtime({ from, ins_t }) {
				if (!lastShowTime) {
					lastShowTime = { from, ins_t };
					return true;
				} else if (from !== lastShowTime.from) {
					lastShowTime = { from, ins_t };
					return true;
				} else if (ins_t > +lastShowTime.ins_t + 120) {
					lastShowTime = { from, ins_t };
					return true;
				}

				return false;
			},
			getDelay(data) {
				if (!data.newAdd) {
					return delay++;
				}
			},
			getTyping(data, id) {
				return data.newAdd && data.from !== 'user' && id === this.chats.length - 1;
			},
			scroll() {
				this.$nextTick(() => {
					const lastElement = this.$refs.chats.children[this.$refs.chats.children.length - 1];
					if (lastElement) {
						const top = lastElement.offsetTop;
						this.$refs.chats.scrollTop = top - 10;
					}
				});
			},
			isCurrent(c, id, chats) {
				const bots = chats.filter(e => e.fid !== 'user' || e.action);
				return bots[bots.length - 1] === c;
			}
		},
		computed: {
			...mapState(['chats']),
			filteredChats() {
				return this.chats.filter(c => !c.hidden && c.type !== 'app');
			}
		},
		beforeMount() {
			lastShowTime = null;
			delay = 0;
			whevent.on('SEND', text => {
				this.onReplyMessage({
					text,
					type: 'text',
					source: 'input'
				});
			});

			whevent.on('MINIAPP_REPLY', data => {
				this.logX('MINIAPP_REPLY', 'gold', data);
				this.onReplyMessage({
					data,
					type: data.type || 'text',
					text: data.textContent || '',
					source: 'miniapp'
				});
			});

			whevent.on('ACTION', data => {
				this.onReplyMessage({
					data,
					type: data.type || 'text',
					text: data.msg || '',
					source: 'action'
				});
			});

			getChat({ source: 'initial' });
		},
		updated() {
			lastShowTime = null;
			delay = 0;
		},
		watch: {
			chats() {
				this.scroll();
			}
		}
	};
</script>

<style scoped lang="scss">
	.Chats {
		padding: 1.6rem;
		scroll-behavior: smooth;
		padding-bottom: 6rem;
	}
</style>
